import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import { DynamicTable } from "@maherunlocker/custom-react-table";
import { useSnapshot } from "valtio";

import { store } from "@components/VerticalLayout/store";
import {
    store as salesModeStore,
    setNumberArchived,
    setNumberActive,
    setLocalShop,
    setIdsLocalShop,
    setModeSaleData,
    setArchivedModeOfSaleFranchise,
    setModeOfSaleFranchise,
    setDataArchive,
    setDataFranchiseArchive,
    setIsActionsClicked,
    setIsEdited,
    setActions,
    setValidationAction,
} from "../store";

import { useCallbackPrompt } from "@hooks/useCallbackPrompt";
import SaleForm from "./SaleForm";
import { GetSalesModesTypesAndTagsV2 } from "./helper";
import { getModeOfSaleUrls } from "./urls";
import { CustomModals } from "./CustomModals";
import { clearData } from "@components/Common/MultiCustomCreatableSelection/store";
import { clearMultiCustomSelectionData } from "@components/Common/MultiCustomSelect/store";

import { getCustomColumns } from "./getCustomColumns";
import {
    DELIVEROO,
    INITIAL_SALE_MODE_FORM_STATE,
    initialUIState,
    updateNumberActiveAndArchive,
} from "./modeOfSaleCheckers";
import SalesMethodHeaderActions from "./SalesMethodHeaderActions";

import "./index.css";
import "@assets/swal.css";
import "@assets/theme.css";
import "react-toastify/dist/ReactToastify.css";
import { useAuthHeader } from "../../../../api/headersKeycloak";
import { useFetchGlobal } from "../../../../api/hooks";

export default function ModeOfSales({
    isModeOfSaleArchived,
    setIsModeOfSaleArchived,
    setLimit,
}: any) {
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();

    const getAuthHeader = useAuthHeader();
    const didMountRef = React.useRef(false);

    const { oneShop, userID, franchiseID, shopID } = useSnapshot(store);
    const {
        isActionsClicked,
        isEdited,
        actions,
        validationAction,
        modify,
        key,
        isLoading,
    } = useSnapshot(salesModeStore);
    const [showPrompt, confirmNavigation, cancelNavigation] = useCallbackPrompt(
        isEdited
    );

    const [rowData, setRowData] = useState<any>({});
    const [dataIsUpdated, setDataIsUpdated] = React.useState<boolean | number>(
        false
    );
    const [isConsult, setIsConsult] = React.useState<boolean>(false);
    const [filterActive, setLocalFilterActive] = React.useState<boolean>(false);
    const [SalesModesTypesAndTag, setSalesModesTypesAndTag] = React.useState<
        any
    >({});
    const [sale, setSale] = useState<any>([]);
    const [shopId, setShopId] = React.useState<string | number>(
        oneShop ? shopID : 0
    );
    const [selectedRows, setSelectedRows] = React.useState<any[]>([]);
    const [dataTable, setDataTable] = React.useState<any>({});
    const [inputSaleMode, setInputSaleMode] = React.useState<boolean>(false);
    const [selectName, setSelectName] = React.useState<boolean>(false);
    const [selectSales, setSelectSales] = React.useState<boolean>(false);
    const [dataState, setDataState] = useState<any>({});
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const [formState, setFormState] = React.useState<any>(
        INITIAL_SALE_MODE_FORM_STATE
    );
    const [modalState, setModalState] = useState({ ...initialUIState });
    const [tagsData, setTagsData] = React.useState<any>([]);
    const [salesSupport, setSalesSupport] = React.useState<any>([]);
    const url = getModeOfSaleUrls({
        userID,
        shopId,
        franchiseID,
        archived: isModeOfSaleArchived,
    });
    const handleAddSalesMethodClick = async () => {
        clearData();
        clearMultiCustomSelectionData();
        setFormState(INITIAL_SALE_MODE_FORM_STATE);
        setFormState((prev: any) => ({
            ...prev,
            displayName: prev.saleMode,
        }));
        setTagsData([]);
        if (formState.saleMode !== "") {
            setSalesSupport(
                salesSupport.filter((sale: string) => sale !== DELIVEROO)
            );
        } else if (formState.saleMode === "") {
            setSalesSupport([]);
        }
        if (isModeOfSaleArchived || isLoading) return;

        setSale([]);
        setSalesSupport([]);
        setSelectSales(false);
        setSelectName(false);
        setInputSaleMode(false);
        setIsConsult(false);
        try {
            const configs = await GetSalesModesTypesAndTagsV2(
                franchiseID,
                shopId,
                fetchGlobal
            );
            const data = configs[0];

            if (!data) return;
            setSalesModesTypesAndTag(data);
            setModalState((prev) => ({
                ...prev,
                isAddModeOfSaleClicked: true,
            }));
            setLocalFilterActive(false);
        } catch (error) {
            console.error("Error fetching sales modes and tags:", error);
        }
    };
    const arrayOfCustomColumns = getCustomColumns({
        setShopId,
        setRowData,
        setSale,
        setDataIsUpdated,
        setSelectedRows,
        isModeOfSaleArchived,
        setSelectName,
        setSelectSales,
        setInputSaleMode,
        selectedRows,
        setLocalFilterActive,
        setIsConsult,
        setDataState,
        setSalesModesTypesAndTag,
        setFormState,
        isConsult,
        setSalesSupport,
        setTagsData,
        modalState,
        setModalState,
    });
    useEffect(() => {
        if (filterActive)
            setModalState((prev) => ({
                ...prev,
                isAddModeOfSaleClicked: false,
            }));

        if (didMountRef.current) {
            setDataIsUpdated(true);
        } else {
            didMountRef.current = true;
        }
    }, [filterActive, i18nextLng]);

    useEffect(() => {
        const localShop: string[] = [];
        const idsLocalShop: string[] = [];

        selectedRows.forEach((el: any) => {
            if (el[t("Shop")] !== "" && el[t("Shop")] !== undefined) {
                localShop.push(el.shopId);
            }
            idsLocalShop.push(el.Id);
        });

        setIdsLocalShop(idsLocalShop);
        setLocalShop(localShop);

        setModeSaleData(dataTable);
        setArchivedModeOfSaleFranchise(dataTable);
        setModeOfSaleFranchise(dataTable);

        setDataArchive(dataTable.othersData?.dataArchive ?? []);
        setDataFranchiseArchive(
            dataTable.othersData?.dataOfFranchiseArchive ?? []
        );
    }, [selectedRows, dataTable, t]);

    useEffect(() => {
        updateNumberActiveAndArchive(
            dataTable,
            setNumberActive,
            setNumberArchived
        );
    }, [dataTable]);

    useEffect(() => {
        setActions(confirmNavigation);
        setIsActionsClicked(showPrompt as boolean);
        setValidationAction(cancelNavigation);
    }, [showPrompt, confirmNavigation, cancelNavigation]);

    return (
        <React.Fragment>
            <div
                className={`
                container-grid 
                ${oneShop ? "height-one-shop" : "height-multi-shop"} 
                ${
                    modalState.isAddModeOfSaleClicked
                        ? "grid-two-columns"
                        : "grid-auto-column"
                }
              `}
                key={key}
            >
                <DynamicTable
                    url={url}
                    requestHeader={{
                        "Accept-Language": i18nextLng,
                        ...getAuthHeader,
                    }}
                    canExpand={false}
                    canSelect
                    customSelect
                    setData={setDataTable}
                    setSelectedRows={setSelectedRows}
                    customJsxSideFilterButton={
                        <SalesMethodHeaderActions
                            modify={modify}
                            modalState={modalState}
                            setModalState={setModalState}
                            handleAddSalesMethodClick={
                                handleAddSalesMethodClick
                            }
                            isModeOfSaleArchived={isModeOfSaleArchived}
                            isLoading={isLoading}
                            sale={sale}
                            isEdited={isEdited}
                            setInputSaleMode={setInputSaleMode}
                            setSelectName={setSelectName}
                            setSelectSales={setSelectSales}
                            selectedRows={selectedRows}
                            setSelectedRows={setSelectedRows}
                            setDataIsUpdated={setDataIsUpdated}
                            setIsModeOfSaleArchived={setIsModeOfSaleArchived}
                            setLimit={setLimit}
                        />
                    }
                    canResize
                    showGlobalFilter
                    showFilter
                    canMovedCheckboxLeftOnExpand
                    setLocalFilterActive={setLocalFilterActive}
                    filterActive={filterActive}
                    actionColumn={() => <></>}
                    arrayOfCustomColumns={arrayOfCustomColumns}
                    setDataIsUpdated={setDataIsUpdated}
                    dataIsUpdated={dataIsUpdated}
                    elevationTable={1}
                    minHeight={oneShop ? "500px" : "450px"}
                    maxHeight={oneShop ? "500px" : "450px"}
                    name="ModeOfSale"
                />
                {modalState.isAddModeOfSaleClicked && (
                    <SaleForm
                        setDataIsUpdated={setDataIsUpdated}
                        dataSale={sale}
                        setDataSale={setSale}
                        setLocalFilterActive={setLocalFilterActive}
                        inputSaleMode={inputSaleMode}
                        setInputSaleMode={setInputSaleMode}
                        selectName={selectName}
                        setSelectName={setSelectName}
                        selectSales={selectSales}
                        setSelectSales={setSelectSales}
                        setLimit={setLimit}
                        setIsConsult={setIsConsult}
                        isConsult={isConsult}
                        dataState={dataState}
                        SalesModesTypesAndTag={SalesModesTypesAndTag}
                        formState={formState}
                        setFormState={setFormState}
                        setSalesSupport={setSalesSupport}
                        salesSupport={salesSupport}
                        setTagsData={setTagsData}
                        tagsData={tagsData}
                        setModalState={setModalState}
                        modalState={modalState}
                        isLoading={isLoading}
                    />
                )}
            </div>

            <CustomModals
                setIsEdited={setIsEdited}
                isActionsClicked={isActionsClicked}
                actions={actions}
                validationAction={validationAction}
                setIsActionsClicked={setIsActionsClicked}
                selectedRows={selectedRows}
                setDataIsUpdated={setDataIsUpdated}
                rowData={rowData}
                isLoading={isLoading}
                setModalState={setModalState}
                modalState={modalState}
                setFormState={setFormState}
            />
        </React.Fragment>
    );
}
